import { useContext } from "react";
import { UserContext } from "context/AppProvider/UserContext";
import SoftBox from "components/SoftBox";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import LokiLogViewer from "./components/LokiLogViewer";

function Logs() {
   const { userData } = useContext(UserContext);

   return (
      <>
         <div
            style={{
               padding: "8px",
               position: "sticky",
               top: 0,
               zIndex: 1000,
               backgroundColor: "var(--main-bg-color)"
            }}
         >
            <DashboardNavbar avatar={userData?.image} />
         </div>
         <DashboardLayout>
            <SoftBox className="portal-logs-frame">
               <Card className="portal-logs-card">
                  <LokiLogViewer />
               </Card>
            </SoftBox>
         </DashboardLayout>
      </>
   );
}

export default Logs;
